module.exports = __webpack_public_path__ + "static/media/WinterborneHome1BookCover.cc900ab3.jpg";